var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFensterVertikal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Vertikal__Icn/40px/Fenster-Vertikal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Vertikal__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fenster-Vertikal__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Vertikal__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fenster-Vertikal__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,28 L21,30 L19,30 L19,28 L21,28 Z M16,10 L16,12 L10,12 L10,26 L16,26 L16,28 L10,28 C8.8954305,28 8,27.1045695 8,26 L8,12 C8,10.8954305 8.8954305,10 10,10 L16,10 Z M30,10 C31.1045695,10 32,10.8954305 32,12 L32,26 C32,27.1045695 31.1045695,28 30,28 L24,28 L24,26 L30,26 L30,12 L24,12 L24,10 L30,10 Z M21,24 L21,26 L19,26 L19,24 L21,24 Z M21,20 L21,22 L19,22 L19,20 L21,20 Z M21,16 L21,18 L19,18 L19,16 L21,16 Z M21,12 L21,14 L19,14 L19,12 L21,12 Z M21,8 L21,10 L19,10 L19,8 L21,8 Z",
    id: ".._.._src_svg_Icn_40px_Fenster-Vertikal__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFensterVertikal);
export default __webpack_public_path__ + "static/media/Fenster-Vertikal.75c24dc3a0fda8bf5460bd7327fd0702.svg";
export { ForwardRef as ReactComponent };